import { createTheme, adaptV4Theme } from "@mui/material/styles";
import spacing from "./spacing";
import overrides from "./overrides";
import typography from "./typography";
import palette from "./palette";

export default createTheme(
  adaptV4Theme({
    typography,
    palette,
    spacing,
    overrides,
  }),
  {
    components: {
      MuiButtonBase: {
        styleOverrides: {
          root: {
            cursor: "pointer",
            "&.Mui-disabled": {
              cursor: "default",
            },
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          "button:not(:disabled)": {
            cursor: "pointer",
          },
          'a[href]:not([aria-disabled="true"])': {
            cursor: "pointer",
          },
        },
      },
    },
  },
);
